import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";

const useRequirementFilterOptions = () => {
  const { requirementService } = useGlobalContext();

  return useQuery(["requirementService.getRequirementFilterOptions"], () =>
    requirementService.getRequirementFilterOptions(),
  );
};

export default useRequirementFilterOptions;
